import { gql } from 'urql';

const FetchNotificationPreferences = gql`
  query FetchNotificationPreferences {
    myNotificationPreferences {
      forWeb {
        id
        name
        description
        channels {
          id
          name
          enabled
        }
      }
      forMobile {
        id
        name
        description
        channels {
          id
          name
          enabled
        }
      }
    }
  }
`;

export default FetchNotificationPreferences;
